namespace TabAurous {

    @Serenity.Decorators.registerEditor()
    export class StoneSieveLookup extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, any> {

        public UseSieveSizeMapping: boolean;
        public BaseItem: number;
        public SizeId: number;
        public SieveId: number;
        public ShapeId: number;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            Administration.ConfigurationService.List({ Code: 1015 }, response => { this.UseSieveSizeMapping = q.ToBool(response.Entities[0].Value) }, { async: false });
            return this.buildLookupKey();
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var customLookup = Q.getLookup(this.buildLookupKey());

            let items: any = super.getItems(customLookup);
            if (this.UseSieveSizeMapping) {
                if (q.isNumber(this.ShapeId)) {

                    let filters = {
                        ShapeId: [this.ShapeId, 0]
                    };
                    items = q.Filter(items, filters);
                }
                else {
                    let filters = {
                        ShapeId: [0]
                    };
                    items = q.Filter(items, filters);
                }
            }
            else {
                let atbid = [];
                for (let item of items) {
                    atbid.push[item.AttributeId];
                }
                atbid.push[0];
                let filters = {
                    AttributeId: atbid
                };
                items = q.Filter(items, filters);

            }
            return items;

        }


        private buildLookupKey(): string {
            if (this.UseSieveSizeMapping) {//if (id == true && BaseItem == 11) {
                return "SieveMapping.Sieve";
            }
            else {
                return "Attribute.Sieve";
            }
        }
    }
}
